module.exports = __webpack_public_path__ + "img/KV_hotel.cbcee5f1.jpg";